import moment from 'moment';

import { formatDate } from './formatters';

export const formatTime = (time: string) => {
  const date = moment(time, 'YYYY-MM-DD', true);
  return date.isValid() ? date.format('dddd MMMM DD, YYYY') : time;
};

export const formatTitle = (value: string) => {
  return value.replace(/_/g, ' ');
};

export const disableWeekends = (dateString: string | null) => {
  if (!dateString) return false;
  const date = moment(dateString);
  const day = date.day();
  return day === 0 || day === 6;
};

export const getPreviousWorkingDay = (dateString: string): string => {
  const date = moment(dateString);
  if (date.day() === 6) return date.subtract(1, 'days').format('YYYY-MM-DD');
  if (date.day() === 0) return date.subtract(2, 'days').format('YYYY-MM-DD');
  return date.format('YYYY-MM-DD');
};

export const formatActivityTime = (timestamp: string) => {
  let date = moment(timestamp);

  if (!date.isValid()) {
    date = moment(timestamp, 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ');
  }

  return date.isValid() ? date.format('YYYY-MM-DD HH:mm') : timestamp;
};

export const oneYearBefore = (): string => {
  const date = moment().subtract(1, 'year');
  return formatDate(date.toISOString());
};

export const getToday = (): string => {
  return formatDate(moment().toISOString());
};
